module.exports = __webpack_public_path__ + "img/westernMedicine.2ee58d52.svg";